module.exports = __webpack_public_path__ + "static/index/img/baikal-103.9ca69d35.jpg";